import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const footerColumnThree = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "Footer Column 3" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation.nodes[0]

}

export default footerColumnThree
